



















































import { TvGeekForLeaderboard } from '@/models/kitchen-tv';
import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'LeaderboardItem',
  props: {
    item: Object as () => TvGeekForLeaderboard,
  },
  computed: {
    lastActivityTimeText(): string {
      // TODO: "Add 2 hours" is workaround for the incorrect timestamp that we get from the API
      return moment(this.item.LastActivityTimeStamp).add(2, 'hours').fromNow();
    },
  },
});
